//@import dependencies
import React, {useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
//@end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import RoleService from 'app_services/admin/role/roleService'
// @end

// @INFO Import Styles
import './../roleFormModule.scss'

// @ADD Component types
interface IRoleFormModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  viewer: boolean
}

const RoleFormModuleLayout: React.FC<IRoleFormModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const formHook = useForm()
  const roleService: RoleService = new RoleService()
  const [listOfPermissions, setListOfPermissions] = useState<Array<any>>([])

  useEffect(() => {
    if (listOfPermissions.length === 0) {
      getAppPermissions()
    }
  }, [listOfPermissions])

  const getAppPermissions = async () => {
    const permissions: Array<any> = []
    const permissionsResponse = await roleService.getPermissions()
    if (permissionsResponse) {
      permissionsResponse.appModulePermissions.map((permission: any) => {
        permissions.push({ value: permission._id, label: permission.name })
      })
    }
    setListOfPermissions(permissions)
  }

  return(
    <div className='role-form'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>
          <div className="row">
            <div className="col-md-6">
              <div className='form-group'>
                <label htmlFor='name'>{t('labels.role_name')}</label>
                {formHook.errors.name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='name'
                  name='name'
                  className={`form-control ${formHook.errors.name && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details.name}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className='form-group'>
                <label htmlFor='description'>{t('labels.role_description')}</label>
                {formHook.errors.description && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='description'
                  name='description'
                  className={`form-control ${formHook.errors.description && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details.description}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='app_module_permissions'>{t('labels.role_permissions')}</label>
                <ReactSelectComponent
                  identifier='app_module_permissions'
                  options={listOfPermissions}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.app_module_permissions) ? props?.editData?.details?.app_module_permissions.map((r: any) => {return {value: r._id, label: r.name}}) : []}
                  isMulti={true}
                  required={true}
                />
              </div>
            </div>
          </div>

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit'>
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}

        </form>
      </fieldset>
    </div>
  )
}

export default RoleFormModuleLayout
